import { LanguageCode } from '@visikon/core-models/languageTypes';
import { SpeakerVoiceNames } from 'containers/composer/block/variationParts/VariationConstants';

export interface VoiceDefinition {
  name: string;
  voice: string;
  variationVoiceName: typeof SpeakerVoiceNames[number];
  languages: LanguageCode[];
}

export const voiceList: VoiceDefinition[] = [
  {
    name: 'Ada',
    voice: 'en-GB-AdaMultilingualNeural',
    variationVoiceName: 'Ada MS',
    languages: [
      // LanguageCode uses ISO 639-1, so region-specific variants map to their base code
      'af',
      'sq',
      'am',
      'ar',
      'hy',
      'az',
      'eu',
      'bn',
      'bs',
      'bg',
      'my',
      'ca',
      'zh',
      'hr',
      'cs',
      'da',
      'nl',
      'en',
      'et',
      'tl',
      'fi',
      'fr',
      'gl',
      'ka',
      'de',
      'el',
      'he',
      'hi',
      'hu',
      'is',
      'id',
      'ga',
      'it',
      'ja',
      'jv',
      'kn',
      'kk',
      'km',
      'ko',
      'lo',
      'lv',
      'lt',
      'mk',
      'ms',
      'ml',
      'mt',
      'mn',
      'ne',
      'nb',
      'ps',
      'fa',
      'pl',
      'pt',
      'ro',
      'ru',
      'sr',
      'si',
      'sk',
      'sl',
      'so',
      'es',
      'su',
      'sw',
      'sv',
      'ta',
      'te',
      'th',
      'tr',
      'uk',
      'ur',
      'uz',
      'vi',
      'cy',
      'zu',
    ],
  },
  {
    name: 'Ava',
    voice: 'en-US-AvaMultilingualNeural',
    variationVoiceName: 'Ava MS',
    languages: [
      // LanguageCode uses ISO 639-1, so region-specific variants map to their base code
      'af',
      'sq',
      'am',
      'ar',
      'hy',
      'az',
      'eu',
      'bn',
      'bs',
      'bg',
      'my',
      'ca',
      'zh',
      'hr',
      'cs',
      'da',
      'nl',
      'en',
      'et',
      'tl',
      'fi',
      'fr',
      'gl',
      'ka',
      'de',
      'el',
      'he',
      'hi',
      'hu',
      'is',
      'id',
      'ga',
      'it',
      'ja',
      'jv',
      'kn',
      'kk',
      'km',
      'ko',
      'lo',
      'lv',
      'lt',
      'mk',
      'ms',
      'ml',
      'mt',
      'mn',
      'ne',
      'nb',
      'ps',
      'fa',
      'pl',
      'pt',
      'ro',
      'ru',
      'sr',
      'si',
      'sk',
      'sl',
      'so',
      'es',
      'su',
      'sw',
      'sv',
      'ta',
      'te',
      'th',
      'tr',
      'uk',
      'ur',
      'uz',
      'vi',
      'cy',
      'zu',
    ],
  },
  {
    name: 'Christel',
    voice: 'da-DK-ChristelNeural',
    variationVoiceName: 'Christel MS',
    languages: ['da'],
  },
];

export const getVoicesForLanguage = (language: LanguageCode): VoiceDefinition[] => voiceList.filter((voice) => voice.languages.includes(language));

export const getDefaultVoiceForLanguage = (language: LanguageCode): VoiceDefinition | undefined => getVoicesForLanguage(language)[0];

export const findVoiceById = (voiceId: string): VoiceDefinition | undefined => voiceList.find((voice) => voice.voice === voiceId);

export const findVoiceByNameAndLanguage = (name: string, language: LanguageCode): VoiceDefinition | undefined =>
  voiceList.find((voice) => voice.name === name && voice.languages.includes(language));
